var map = {
	"./font/MabryBuckIconsLight.woff": 78999,
	"./font/MabryPro-Black.woff2": 40645,
	"./font/MabryPro-BlackItalic.woff2": 18645,
	"./font/MabryPro-Bold.woff2": 70529,
	"./font/MabryPro-BoldItalic.woff2": 30791,
	"./font/MabryPro-Italic.woff2": 4855,
	"./font/MabryPro-Light.woff2": 33134,
	"./font/MabryPro-LightItalic.woff2": 73397,
	"./font/MabryPro-Medium.woff2": 19239,
	"./font/MabryPro-MediumItalic.woff2": 8486,
	"./font/MabryPro-Regular.woff2": 14680,
	"./font/mabry-buck-icons.woff2": 43518,
	"./font/mabry-light-pro.eot": 25579,
	"./font/mabry-light-pro.ttf": 70946,
	"./font/mabry-light-pro.woff": 58323,
	"./font/mabry-light-pro.woff2": 55537,
	"./font/mabry-medium-pro.eot": 88098,
	"./font/mabry-medium-pro.ttf": 59598,
	"./font/mabry-medium-pro.woff": 65823,
	"./font/mabry-medium-pro.woff2": 73702,
	"./font/mabry-mono-italic-pro.woff": 20984,
	"./font/mabry-mono-italic-pro.woff2": 25004,
	"./font/mabry-mono-medium-pro.woff": 86332,
	"./font/mabry-mono-medium-pro.woff2": 8177,
	"./font/mabry-mono-regular-pro.woff": 44158,
	"./font/mabry-mono-regular-pro.woff2": 12909,
	"./font/mabry-regular-pro.eot": 10602,
	"./font/mabry-regular-pro.ttf": 84202,
	"./font/mabry-regular-pro.woff": 50361,
	"./font/mabry-regular-pro.woff2": 2417,
	"./image/answer/multiple-choice/cloud_00.png": 91861,
	"./image/answer/multiple-choice/cloud_01.png": 57458,
	"./image/answer/multiple-choice/cloud_02.png": 63341,
	"./image/answer/multiple-choice/cloud_03.png": 13163,
	"./image/answer/multiple-choice/cloud_04.png": 67875,
	"./image/answer/multiple-choice/cloud_05.png": 9220,
	"./image/answer/multiple-choice/cloud_06.png": 8165,
	"./image/background/buddy-earth.jpg": 75682,
	"./image/background/buddy-fire.jpg": 40050,
	"./image/background/buddy-metal.jpg": 74185,
	"./image/background/buddy-water.jpg": 87231,
	"./image/background/buddy-wood.jpg": 16440,
	"./image/background/prospect-earth.jpg": 72741,
	"./image/background/prospect-fire.jpg": 5223,
	"./image/background/prospect-metal.jpg": 35892,
	"./image/background/prospect-water.jpg": 5636,
	"./image/background/prospect-wood.jpg": 85904,
	"./image/background/shareable-matte.jpg": 54467,
	"./image/background/starry-background.webp": 33844,
	"./image/birthdate/birthdate-trail.png": 11431,
	"./image/birthdate/pointer.png": 94612,
	"./image/branding/buck-icon.png": 22006,
	"./image/branding/zoodi-alt.png": 29952,
	"./image/branding/zoodi-star.png": 36387,
	"./image/branding/zoodi-star.svg": 90478,
	"./image/branding/zoodi.png": 60010,
	"./image/bubble/bunny-large.png": 50094,
	"./image/bubble/bunny-mid-opposite.png": 79403,
	"./image/bubble/bunny-mid.png": 40278,
	"./image/bubble/bunny-small-opposite.png": 97847,
	"./image/bubble/bunny-small.png": 35272,
	"./image/bubble/bunny-tiny.png": 97065,
	"./image/bubble/dragon-large.png": 14885,
	"./image/bubble/dragon-mid-opposite.png": 93013,
	"./image/bubble/dragon-mid.png": 19879,
	"./image/bubble/dragon-small-opposite.png": 44797,
	"./image/bubble/dragon-small.png": 15288,
	"./image/bubble/dragon-tiny.png": 85946,
	"./image/card/texture/ancient.png": 63225,
	"./image/card/texture/angular.png": 57933,
	"./image/card/texture/cosmos-bottom-trans.png": 11245,
	"./image/card/texture/cosmos-bottom.png": 75615,
	"./image/card/texture/cosmos-middle-trans.png": 23886,
	"./image/card/texture/cosmos-middle.gif": 11796,
	"./image/card/texture/cosmos-middle.png": 66168,
	"./image/card/texture/cosmos-top-trans.png": 22253,
	"./image/card/texture/cosmos-top.png": 83723,
	"./image/card/texture/cosmos.png": 77817,
	"./image/card/texture/crossover.png": 94113,
	"./image/card/texture/galaxy-source.png": 35929,
	"./image/card/texture/galaxy.jpg": 58467,
	"./image/card/texture/geometric.png": 11944,
	"./image/card/texture/glitter.png": 61391,
	"./image/card/texture/grain.webp": 26910,
	"./image/card/texture/illusion-mask.png": 10729,
	"./image/card/texture/illusion.png": 36278,
	"./image/card/texture/illusion2.png": 14418,
	"./image/card/texture/metal.png": 82467,
	"./image/card/texture/rainbow.jpg": 19965,
	"./image/card/texture/stylish.png": 93659,
	"./image/card/texture/stylish2.png": 88873,
	"./image/card/texture/trainerbg.jpg": 57567,
	"./image/card/texture/trainerbg.png": 65184,
	"./image/card/texture/vmaxbg.jpg": 27413,
	"./image/card/texture/wave.png": 51695,
	"./image/character/bunny/accessory/idle_00.png": 93620,
	"./image/character/bunny/accessory/tear_00.png": 62363,
	"./image/character/bunny/blink/happy_00.png": 64103,
	"./image/character/bunny/blink/idle_00.png": 52730,
	"./image/character/bunny/blink/sad_00.png": 52659,
	"./image/character/bunny/body/down_00.png": 19558,
	"./image/character/bunny/body/idle_00.png": 84545,
	"./image/character/bunny/eye/happy_00.png": 26210,
	"./image/character/bunny/eye/idle_00.png": 3189,
	"./image/character/bunny/eye/sad_00.png": 61577,
	"./image/character/bunny/eye/sad_01.png": 94276,
	"./image/character/bunny/eye/surprised_00.png": 13735,
	"./image/character/bunny/eyelid/idle_00.png": 55239,
	"./image/character/bunny/eyelid/sad_00.png": 88112,
	"./image/character/bunny/eyelid/sad_01.png": 21175,
	"./image/character/bunny/face/happy_00.png": 60551,
	"./image/character/bunny/face/happy_01.png": 25541,
	"./image/character/bunny/face/idle_00.png": 76425,
	"./image/character/bunny/face/sad_00.png": 94409,
	"./image/character/bunny/face/sad_01.png": 39003,
	"./image/character/bunny/face/sad_02.png": 43778,
	"./image/character/bunny/face/surprised_00.png": 9008,
	"./image/character/bunny/face/surprised_01.png": 86210,
	"./image/character/bunny/pupil/idle_00.png": 23053,
	"./image/character/bunny/pupil/surprised_00.png": 43488,
	"./image/character/bunny/shadow/down_00.png": 8665,
	"./image/character/bunny/shadow/idle_00.png": 77195,
	"./image/character/dragon/accessory/idle_00.png": 72997,
	"./image/character/dragon/accessory/tear_00.png": 72440,
	"./image/character/dragon/beard/idle_00.png": 80018,
	"./image/character/dragon/beard/shocked_00.png": 64289,
	"./image/character/dragon/body/idle_00.png": 62361,
	"./image/character/dragon/body/shocked_00.png": 86273,
	"./image/character/dragon/eyelid/blink_00.png": 63810,
	"./image/character/dragon/eyelid/cry_00.png": 47590,
	"./image/character/dragon/eyelid/half_00.png": 98286,
	"./image/character/dragon/eyelid/idle_00.png": 79738,
	"./image/character/dragon/eyelid/sad_00.png": 91194,
	"./image/character/dragon/eyelid/winkleft_00.png": 47579,
	"./image/character/dragon/eyelid/winkright_00.png": 52233,
	"./image/character/dragon/mouth/happy_00.png": 84293,
	"./image/character/dragon/mouth/happy_01.png": 60094,
	"./image/character/dragon/mouth/happy_02.png": 99468,
	"./image/character/dragon/mouth/happy_03.png": 37403,
	"./image/character/dragon/mouth/happy_04.png": 37569,
	"./image/character/dragon/mouth/happy_05.png": 3563,
	"./image/character/dragon/mouth/idle_00.png": 42422,
	"./image/character/dragon/mouth/oh_00.png": 49053,
	"./image/character/dragon/mouth/oh_01.png": 78569,
	"./image/character/dragon/mouth/sad_00.png": 45519,
	"./image/character/dragon/mouth/sad_01.png": 73849,
	"./image/character/dragon/mouth/shocked_00.png": 51521,
	"./image/character/dragon/pupil/idle_00.png": 85196,
	"./image/character/dragon/pupil/shocked_00.png": 64359,
	"./image/character/dragon/pupil/sparkle_00.png": 20481,
	"./image/character/dragon/pupil/sparkle_01.png": 88525,
	"./image/character/dragon/shadow/idle_00.png": 68395,
	"./image/character/dragon/shadow/shocked_00.png": 49166,
	"./image/cloud/cloud-01.png": 90646,
	"./image/cloud/cloud-02.png": 6567,
	"./image/cloud/cloud-03.png": 72082,
	"./image/cloud/cloud-04.png": 85040,
	"./image/cloud/cloud-05.png": 92293,
	"./image/cloud/cloud-06.png": 56257,
	"./image/cloud/cloud-07.png": 53438,
	"./image/cloud/cloud-08.png": 16453,
	"./image/cloud/cloud-09.png": 97993,
	"./image/cloud/cloud-10.png": 30919,
	"./image/cloud/cloud-11.png": 72047,
	"./image/cloud/cloud-12.png": 57260,
	"./image/cloud/cloud-13.png": 93591,
	"./image/cloud/cloud-14.png": 36312,
	"./image/cloud/cloud-15.png": 60450,
	"./image/cloud/cloud-16.png": 66028,
	"./image/cloud/cloud-17.png": 37532,
	"./image/emoji/cocoon-sleeping-bag.png": 92128,
	"./image/emoji/dryer-lint.png": 19505,
	"./image/emoji/epic-magnet.png": 93379,
	"./image/emoji/extra-heat-hot-sauce.png": 13396,
	"./image/emoji/fussy-toaster.png": 74002,
	"./image/emoji/fuzzy-animal-slippers.png": 84031,
	"./image/emoji/keychain-with-too-many-keys.png": 48410,
	"./image/emoji/last-piece-of-gum.png": 39941,
	"./image/emoji/origami-star.png": 98429,
	"./image/emoji/overripe-banana.png": 26446,
	"./image/emoji/sprouting-potato.png": 71790,
	"./image/emoji/treasure-map.png": 29221,
	"./image/emoji/trusty-rubber-duck.png": 18864,
	"./image/emoji/uno-reverse-card.png": 84653,
	"./image/emoji/used-glow-stick.png": 36615,
	"./image/envelope/body.png": 89846,
	"./image/envelope/flap-closed.png": 19513,
	"./image/envelope/flap-opened.png": 7783,
	"./image/envelope/sticker.png": 61959,
	"./image/flag/de.svg": 56632,
	"./image/flag/en.svg": 37699,
	"./image/flag/es.svg": 49548,
	"./image/flag/fr.svg": 22647,
	"./image/flag/ja.svg": 18639,
	"./image/flag/zh.svg": 63875,
	"./image/gesture/arrow-left.png": 2797,
	"./image/gesture/slide.png": 99425,
	"./image/gesture/swipe.png": 75346,
	"./image/gesture/tap.png": 86530,
	"./image/icon/audio-off.svg": 74474,
	"./image/icon/audio-on.svg": 53995,
	"./image/icon/celestial-close.svg": 46855,
	"./image/icon/medium-star.png": 75558,
	"./image/icon/menu.svg": 82391,
	"./image/icon/pointer-drag.svg": 43844,
	"./image/icon/tiny-star.png": 69336,
	"./image/lucky-buddy/cocoon-sleeping-bag.png": 57763,
	"./image/lucky-buddy/dryer-lint.png": 33267,
	"./image/lucky-buddy/epic-magnet.png": 20103,
	"./image/lucky-buddy/extra-heat-hot-sauce.png": 56665,
	"./image/lucky-buddy/fussy-toaster.png": 54049,
	"./image/lucky-buddy/fuzzy-animal-slippers.png": 44148,
	"./image/lucky-buddy/keychain-with-too-many-keys.png": 18518,
	"./image/lucky-buddy/last-piece-of-gum.png": 36794,
	"./image/lucky-buddy/origami-stars.png": 24711,
	"./image/lucky-buddy/overripe-banana.png": 59927,
	"./image/lucky-buddy/sprouting-potato.png": 99020,
	"./image/lucky-buddy/treasure-map.png": 23766,
	"./image/lucky-buddy/trusty-rubber-duck.png": 71981,
	"./image/lucky-buddy/uno-reverse-card.png": 11437,
	"./image/lucky-buddy/used-glow-stick.png": 59049,
	"./image/mask/color-curve-02.png": 38831,
	"./image/mask/color-curve-03.png": 79761,
	"./image/mask/color-curve-04.png": 89669,
	"./image/mask/color-curve-05.png": 53522,
	"./image/mask/color-curve.png": 99008,
	"./image/mask/land-2-alt.png": 26850,
	"./image/mask/land-2.png": 24752,
	"./image/mask/pearl-00.png": 6818,
	"./image/mask/pearl-01.png": 91315,
	"./image/mask/pearl-2.png": 88994,
	"./image/orb/career.svg": 84913,
	"./image/orb/general.svg": 21520,
	"./image/orb/health.svg": 30618,
	"./image/orb/love.svg": 95763,
	"./image/orb/wealth.svg": 2027,
	"./image/starfield-alt/background.png": 33537,
	"./image/starfield-alt/cloud-1.png": 66243,
	"./image/starfield-alt/cloud-2.png": 99489,
	"./image/starfield-alt/cloud-3.png": 91613,
	"./image/starfield-alt/cloud-4.png": 33549,
	"./image/starfield-alt/cloud-5.png": 76034,
	"./image/starfield-alt/desktop-cloud-1.png": 33820,
	"./image/starfield-alt/desktop-cloud-2.png": 12882,
	"./image/starfield-alt/desktop-cloud-3.png": 39631,
	"./image/starfield-alt/desktop-cloud-4.png": 79427,
	"./image/starfield-alt/desktop-cloud-5.png": 88328,
	"./image/starfield-alt/land-1.png": 90745,
	"./image/starfield-alt/land-2.png": 43378,
	"./image/starfield-alt/mountain-a.png": 65909,
	"./image/starfield-alt/mountain-b.png": 94055,
	"./image/starfield-alt/mountain-c.png": 59590,
	"./image/starfield-alt/mountain-d.png": 48284,
	"./image/starfield-alt/mountain-e.png": 69999,
	"./image/starfield-alt/mountain-f.png": 79816,
	"./image/starfield-alt/mountain-g.png": 65958,
	"./image/starfield-alt/mountain-h.png": 51772,
	"./image/starfield-alt/mountain-i.png": 12451,
	"./image/starfield-alt/small/cloud-1.png": 55065,
	"./image/starfield-alt/small/cloud-2.png": 1513,
	"./image/starfield-alt/small/cloud-3.png": 46606,
	"./image/starfield-alt/small/cloud-4.png": 66958,
	"./image/starfield-alt/small/cloud-5.png": 588,
	"./image/starfield-alt/small/desktop-cloud-1.png": 26831,
	"./image/starfield-alt/small/desktop-cloud-2.png": 57792,
	"./image/starfield-alt/small/desktop-cloud-3.png": 52048,
	"./image/starfield-alt/small/desktop-cloud-4.png": 90267,
	"./image/starfield-alt/small/desktop-cloud-5.png": 38921,
	"./image/starfield-alt/small/land-1.png": 26968,
	"./image/starfield-alt/small/land-1.webp": 36636,
	"./image/starfield-alt/small/land-2.png": 82262,
	"./image/starfield-alt/small/land-2.webp": 12847,
	"./image/starfield-alt/small/mountain-a.png": 88773,
	"./image/starfield-alt/small/mountain-a.webp": 11884,
	"./image/starfield-alt/small/mountain-b.png": 11166,
	"./image/starfield-alt/small/mountain-b.webp": 19821,
	"./image/starfield-alt/small/mountain-c.png": 94250,
	"./image/starfield-alt/small/mountain-c.webp": 13234,
	"./image/starfield-alt/small/mountain-d.png": 46910,
	"./image/starfield-alt/small/mountain-d.webp": 791,
	"./image/starfield-alt/small/mountain-e.png": 93002,
	"./image/starfield-alt/small/mountain-e.webp": 47729,
	"./image/starfield-alt/small/mountain-f.png": 3642,
	"./image/starfield-alt/small/mountain-f.webp": 5079,
	"./image/starfield-alt/small/mountain-g.png": 22791,
	"./image/starfield-alt/small/mountain-g.webp": 91965,
	"./image/starfield-alt/small/mountain-h.png": 90407,
	"./image/starfield-alt/small/mountain-h.webp": 99221,
	"./image/starfield-alt/small/mountain-i.png": 92887,
	"./image/starfield-alt/small/mountain-i.webp": 51947,
	"./image/starfield-alt/sun.png": 17928,
	"./image/starfield/background.png": 54599,
	"./image/starfield/cloud_00.png": 84169,
	"./image/starfield/cloud_01.png": 85734,
	"./image/starfield/cloud_02.png": 67365,
	"./image/starfield/cloud_03.png": 24609,
	"./image/starfield/cloud_04.png": 39756,
	"./image/starfield/fog_00.png": 86311,
	"./image/starfield/gradient_00.jpg": 25414,
	"./image/starfield/gradient_00.png": 8439,
	"./image/starfield/gradient_00.svg": 86466,
	"./image/starfield/gradient_01.png": 47298,
	"./image/starfield/land_00.png": 92313,
	"./image/starfield/land_01.png": 11137,
	"./image/starfield/mountain_00.png": 96344,
	"./image/starfield/mountain_01.png": 87614,
	"./image/starfield/mountain_02.png": 44001,
	"./image/starfield/mountain_03.png": 26271,
	"./image/starfield/shootingstar_00.png": 25840,
	"./image/starfield/sun_00.png": 87906,
	"./image/zodiac/dog.png": 13628,
	"./image/zodiac/dragon.png": 88769,
	"./image/zodiac/goat.png": 17274,
	"./image/zodiac/horse.png": 54723,
	"./image/zodiac/monkey.png": 76716,
	"./image/zodiac/ox.png": 80416,
	"./image/zodiac/pig.png": 42797,
	"./image/zodiac/rabbit.png": 12024,
	"./image/zodiac/rat.png": 84272,
	"./image/zodiac/rooster.png": 43197,
	"./image/zodiac/snake.png": 82722,
	"./image/zodiac/tiger.png": 12135,
	"./json/ai-chatter": 38198,
	"./json/ai-chatter.json": 38198,
	"./json/cloud/bunny-00": 26625,
	"./json/cloud/bunny-00.json": 26625,
	"./json/cloud/bunny-01": 95548,
	"./json/cloud/bunny-01.json": 95548,
	"./json/cloud/cluster-00": 38139,
	"./json/cloud/cluster-00.json": 38139,
	"./json/cloud/dispersed-00": 32193,
	"./json/cloud/dispersed-00.json": 32193,
	"./json/cloud/dragon-00": 90091,
	"./json/cloud/dragon-00.json": 90091,
	"./json/cloud/dragon-01": 60636,
	"./json/cloud/dragon-01.json": 60636,
	"./json/cloud/heart-00": 44751,
	"./json/cloud/heart-00.json": 44751,
	"./json/cloud/heart-old": 48991,
	"./json/cloud/heart-old.json": 48991,
	"./json/cloud/pairs": 96226,
	"./json/cloud/pairs.ts": 96226,
	"./json/cloud/pairs.txt": 58858,
	"./json/cloud/spiral-old": 69285,
	"./json/cloud/spiral-old.json": 69285,
	"./json/cloud/star-00": 9613,
	"./json/cloud/star-00.json": 9613,
	"./json/cloud/star-01": 2268,
	"./json/cloud/star-01.json": 2268,
	"./json/cloud/triangle-00": 65723,
	"./json/cloud/triangle-00.json": 65723,
	"./json/interactions": 83285,
	"./json/interactions.ts": 83285,
	"./json/lucky-buddies": 37165,
	"./json/lucky-buddies.json": 37165,
	"./lang": 9176,
	"./lang/": 9176,
	"./lang/de": 5532,
	"./lang/de.ts": 5532,
	"./lang/en": 60842,
	"./lang/en.ts": 60842,
	"./lang/es": 74206,
	"./lang/es.ts": 74206,
	"./lang/fr": 55992,
	"./lang/fr.ts": 55992,
	"./lang/index": 9176,
	"./lang/index.ts": 9176,
	"./lang/ja": 10241,
	"./lang/ja.ts": 10241,
	"./lang/zh": 77368,
	"./lang/zh.ts": 77368,
	"./sound/background-loop.mp3": 28695,
	"./sound/background-music.mp3": 76043,
	"./sound/background-opening.mp3": 91730,
	"./sound/character-speech-a.mp3": 14290,
	"./sound/character-speech-b.mp3": 62,
	"./sound/click-a.mp3": 73193,
	"./sound/click-b.mp3": 24474,
	"./sound/click-c.mp3": 10090,
	"./sound/envelope-a.mp3": 7786,
	"./sound/envelope-b.mp3": 14593,
	"./sound/flipcard-a.mp3": 36826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18668;